// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Hero__Wrapper_dqiYS grid grid--col-12","Head":"Hero__Head_2Ug55","Title":"Hero__Title_2CrPg"};